import React, { Component } from 'react';
import formUrlParams from 'Helpers/urlform';
import DataTable from 'Components/Table/dataTable';
import Pagination from 'Components/Pagination/index';
import { tableConstants } from 'Constants';
import SearchBar from 'Components/Common/SearchBar';
import { ReactComponent as Search } from 'assets/images/svg/search-icon.svg';
import { ReactComponent as Close } from 'assets/images/svg/Popclose.svg';

class AddTeamUsers extends Component {
    constructor(props) {
        super(props);
        const pageLimit = 10;
        this.state = {
            headers:[
                {
                    title:'checkbox',
                    sortOption: false,
                    headerCell: () => {
                        return '';
                    },
                    cell: (rowDetail, rec) => {
                        const { index, id, rowIdx, content, profile, ...rest } = rowDetail;
                        const isChecked = !!this.state.selectedRows[ rest.username ];
                        return <td key={ index } data-row={ rowIdx } className={ tableConstants.CHECKBOX_WIDTH } >
                            <div className={ `thcus-checkbox cus-checkbox${ isChecked ? ' active' : '' }` } 
                            onClick={ () => this.toggleRow(rest) }
                            >
                                <input type="checkbox" defaultChecked={ isChecked }/>
                                <span>
                                    <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" fill="none" stroke-width="2px" stroke="#262626" stroke-linecap="round" viewBox="0 0 21 21">
                                        <polyline points="5 10.75 8.5 14.25 16 6"></polyline>
                                    </svg>
                                </span>
                            </div>
                        </td>
                    }
                },
                {
                title: 'Name',
                chooseOption: {
                    name: 'fullNameSearch' /* API param name */,
                    Component: 'Search',
                    dispatchFunction: this.handleSearch,
                },
                combineapidata: [ 'name', 'image' ],
                accessor: 'name' /* API response */,
                cell: {
                    type: 'image-with-name',
                },
                tooltip: true
                },
                {
                title: 'Email',
                chooseOption: {
                    name: 'emailIdSearch' /* API param name */,
                    Component: 'Search',
                    dispatchFunction: this.handleSearch,
                },
                accessor: 'emailId',
                tooltip: true
                }
            ],
            filtered: [ { id: 'size', value: pageLimit }, { id: 'page', value: 1 } ],
            pageLimit,
            selectedRows:{},
            userNames: props.teamMembers.map(member => member.username)
        }

        this.props.fetchUsers(this.state.filtered, { userNames: this.state.userNames });
    }

    handleUsersList = () => {
        const { usersList, teamMembers = [] } = this.props;
        const updatedList = [
          ...usersList
        ];

        return updatedList.reduce((acc, current) => {
          const username = current.username || current.username;
          const x = acc.find(item => item.username === username);
          const existIndex = teamMembers.findIndex((member) => member.username === username);
          if (!x && existIndex === -1) {
            const updatedUsersList = {
              ...current
            }
            return acc.concat([ updatedUsersList ]);
          } else {
            return acc;
          }
        }, []);
    }

    formUrlParams = (name, value, rest) => {
        const { filtered } = this.state;
        const filterResponse = formUrlParams(filtered, name, value);
        this.setState({ filtered: filterResponse, ...rest }, () => {
          this.props.fetchUsers(this.state.filtered, { userNames: this.state.userNames });
        });
    }

    setPageLimit = (name, value) => {
        this.formUrlParams(name, value, { pageLimit: value });
    };

    toggleRow = (rowDetail) => {
        if(rowDetail?.username){
            const selectedRows = { ...this.state.selectedRows };
            if( !this.state.selectedRows[ rowDetail.username ] ){
                selectedRows[ rowDetail.username ] = rowDetail;
            }
            else{
                delete selectedRows[ rowDetail.username ];
            }
            this.setState( { selectedRows } );
        }

    }

    addTeamMembers = (event) => {
        event.preventDefault();
        const selectedRows = this.state.selectedRows;
        if(Object.keys(selectedRows).length > 0){
            this.props.handleAddTeamMembers(selectedRows);
            this.props.toggleAddTeamUsersPopup();
        }
    }

    handleSearch = (event) => {
        const { name, value } = event.target;
        this.setState({ [ name ]: value }, () =>
          this.formUrlParams(name, value)
        );
    };

    render(){

        return (
            <div className='ctPopup_container popup_bg team_popup'>
                <div className='ctPopup_wrp'>
                <div className='ctPopup_head'>
                    <h4>Add Users</h4>
                    <i  onClick={ () => this.props.toggleAddTeamUsersPopup() } className='ctPopup_close'><Close/></i>
                </div>
                <div className='ctPopup_content'>
                    <DataTable
                        className='data-table'
                        keyField='id'
                        headers={ this.state.headers }
                        data={ this.handleUsersList() }
                        noData='No records!'
                    />
                    <Pagination
                        handleClick={ this.formUrlParams }
                        totalRecords={ this.props.usersTotalRecords }
                        initialPage={ this.props.usersCurrentPage }
                        setPageLimit={ this.setPageLimit }
                        pageLimit={ this.state.pageLimit }
                    />
                </div>
                <div className='ctPopup_footer'>
                    <button className='btn btn_outline' onClick={ () => this.props.toggleAddTeamUsersPopup() }>Cancel</button>
                    <button className='btn btn_primary' onClick={ this.addTeamMembers }>Add</button>
                </div>
                </div>
            </div>
        )
    }
}

export default AddTeamUsers;